// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i2QA","tabsBox":"styles_tabsBox__1ZwNn","createButton":"styles_createButton__3_5qe"};